import React from 'react';
import MockupShell from './MockupShell';

const INBOX = [
  { from: 'Admin · BBC Quick List',     subject: 'Phase 2 unlock criteria updated',   when: '2h ago',   pinned: true },
  { from: 'Justin H.',                  subject: 'New training drop — 7 min watch',   when: '5h ago',   pinned: false },
  { from: 'Maria G.',                   subject: 'Builder check-in: how was week 1?', when: '1d ago',   pinned: false },
  { from: 'Admin · BBC Quick List',     subject: 'Welcome to the Safe List',          when: '3d ago',   pinned: false },
];

export default function SafeList() {
  return (
    <MockupShell
      title="Safe List / Builder Mailer"
      subtitle="Opt-in internal mailing channel for active builders. Members mail members — admin sets compliance rules."
      dataTestId="mockup-safe-list"
    >
      <div className="mk-compliance" style={{ marginBottom: 16 }}>
        <strong>Compliance rules (enforced).</strong> No income guarantees. No medical or financial
        promises. No spam. No racial, sexual, or hate content. No external recruitment for
        non-BBC-approved programs. Each message costs Mailer Credits and is rate-limited per
        builder. Repeat violations remove mailer access.
      </div>

      <div className="mk-grid mk-grid--3" style={{ marginBottom: 18 }}>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Mailer Credits</span><span className="mk-stat-value">24</span><span className="mk-stat-sub">+5 weekly refresh on Mondays</span></div></div>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Sent this week</span><span className="mk-stat-value">3</span><span className="mk-stat-sub">Avg open rate 41%</span></div></div>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Audience size</span><span className="mk-stat-value">847</span><span className="mk-stat-sub">Active opt-in builders</span></div></div>
      </div>

      <div className="mk-grid mk-grid--2">
        {/* Compose */}
        <div className="mk-card">
          <h3 style={{ marginBottom: 12 }}>Compose new message</h3>
          <label style={{ fontSize: 11, color: 'var(--mk-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Subject</label>
          <input className="mk-input" defaultValue="Sharing a quick tip from week 2" style={{ marginTop: 6, marginBottom: 12 }} data-testid="safelist-subject-input" />
          <label style={{ fontSize: 11, color: 'var(--mk-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Body</label>
          <textarea
            className="mk-textarea"
            rows={6}
            defaultValue={"Hey fellow builders,\n\nQuick share: posting once a day inside one Telegram group has worked better for me than spamming five. Quality > volume.\n\n— Builder #4827"}
            style={{ marginTop: 6, marginBottom: 12 }}
            data-testid="safelist-body-textarea"
          />
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <button className="mk-btn" data-testid="safelist-send-btn">Send · 1 credit</button>
            <button className="mk-btn mk-btn--ghost">Schedule</button>
            <button className="mk-btn mk-btn--ghost">Save draft</button>
            <span style={{ marginLeft: 'auto', fontSize: 11, color: 'var(--mk-muted)' }}>Auto-scanned for compliance violations on send.</span>
          </div>
        </div>

        {/* Inbox */}
        <div className="mk-card" style={{ padding: 0 }}>
          <div style={{ padding: '14px 18px', borderBottom: '1px solid var(--mk-border)' }}>
            <h3 style={{ margin: 0 }}>Inbox</h3>
          </div>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {INBOX.map((m, i) => (
              <li key={m.subject} data-testid={`safelist-message-${i}`} style={{ padding: '12px 18px', borderBottom: i < INBOX.length - 1 ? '1px solid var(--mk-border)' : 'none' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                  <strong style={{ fontSize: 13 }}>{m.subject}</strong>
                  {m.pinned && <span className="mk-badge mk-badge--gold">Pinned</span>}
                </div>
                <div style={{ fontSize: 11, color: 'var(--mk-muted)', marginTop: 4 }}>{m.from} · {m.when}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </MockupShell>
  );
}
